import Guest from './Guest';
import { PAYMENT_METHOD } from './Payment';

export interface ReservationAccommodationInfo {
  name: string;
  id: string;
  packageId?: string;
  packageName?: string;
  adults: number;
  kids: number;
  total: number;
}

export default class Reservation {
  status!: boolean;
  error?: string;

  propertyId!: number;
  date!: Date;
  paymentMethod!: PAYMENT_METHOD;
  reservationStatus!: string;
  reservationId!: number;

  lang?: string;
  checkin!: Date;
  checkout!: Date;

  nights!: number;

  charges_paid_value!: number;
  charges_subtotal!: number;
  charges_upgrades!: number;
  charges_total!: number;
  charges_deposit!: number;
  charges_tax!: number;
  charges_balance_due!: number;

  accommodations: ReservationAccommodationInfo[] = [];
  guests: Guest[] = [];

  constructor(data?: Dict) {
    if (!data || !data.success || !data.data) {
      this.status = false;
      this.error = data?.message || 'Unknow error';
      return;
    }

    const { data: reservation } = data;

    this.status = true;
    this.propertyId = parseInt(reservation.property_id);
    this.date = new Date(reservation.created_at);
    this.paymentMethod = reservation.payment_method;
    this.reservationStatus = reservation.mail_info.status;
    this.reservationId = parseInt(reservation.identifier);

    this.checkin = new Date(reservation.mail_info.checkin_date + 'T00:00:00');
    this.checkout = new Date(reservation.mail_info.checkout_date + 'T00:00:00');
    this.nights = parseInt(reservation.mail_info.nights);

    this.charges_paid_value = parseFloat(reservation.paid_value);
    this.charges_upgrades = 0;
    this.charges_subtotal = parseFloat(reservation.mail_info.rooms_total);
    this.charges_total = parseFloat(reservation.total);
    this.charges_deposit = parseFloat(reservation.deposit);
    this.charges_tax = 0; // todo: fix it using a example that use taxeso: fix it using a example that use taxes
    this.charges_balance_due = parseFloat(reservation.mail_info.balance_due); // todo: fix it using a example that use taxeso: fix it using a example that use taxes

    const guest = new Guest();
    guest.firstName = reservation.mail_info.first_name;
    guest.lastName = reservation.mail_info.last_name;
    guest.email = reservation.mail_info.email;
    guest.phone = reservation.mail_info.phone;
    guest.country = reservation.mail_info.country;

    this.guests.push(guest);

    this.lang = reservation.mail_info.lang;

    this.accommodations = [];
    for (const room of reservation.mail_info.booking_rooms) {
      const item: ReservationAccommodationInfo = {
        name: room.room_type_name,
        id: room.room_type_id,
        packageId: room.package,
        packageName: room.package_name || 'Standard Rate',
        adults: parseInt(room.adults),
        kids: parseInt(room.kids),
        total: parseFloat(room.total),
      };

      this.accommodations.push(item);
    }
  }
}
